export enum CompanySettingsStatus {
  Active = 1,
  Removed = 2,
}
